function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgExternalHealthResources = function SvgExternalHealthResources(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "M12 21c4.958-4.782 7-7.465 7-10.3C19 6.447 16.007 3 11.899 3S5 6.447 5 10.7c0 2.835 2.042 5.518 7 10.3Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    d: "M14.692 10.313c0 1.553-1.205 2.812-2.692 2.812s-2.692-1.26-2.692-2.812C9.308 8.759 10.513 7.5 12 7.5s2.692 1.26 2.692 2.813Z"
  }));
};
export default SvgExternalHealthResources;